var ur = window.location.href;
if(ur.includes('/product')){
  
  jQuery(document).ready(function(){
    jQuery('.product-form__buttons').prepend(jQuery('.product-form__input.product-form__quantity').eq(0));
    jQuery('.product-form__input.product-form__quantity').eq(0).append(jQuery('.product__tax.caption.rte'))

Element.prototype.appendAfter = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var imgSrcs = ['https://cdn.shopify.com/s/files/1/0550/6986/8249/files/secure.png?v=1649996670',  
'https://cdn.shopify.com/s/files/1/0550/6986/8249/files/shipping.png?v=1649996670', 
'https://cdn.shopify.com/s/files/1/0550/6986/8249/files/return.png?v=1649996670',
'https://cdn.shopify.com/s/files/1/0550/6986/8249/files/guarantee.png?v=1649996670',
              'https://cdn.shopify.com/s/files/1/0550/6986/8249/files/price-match.png?v=1706152175'];
var badgeTexts = ["Secure Checkout",
                  "Free Shipping",
                  "Return Policy",
		"Warranty and Guarantee",
                 "Price Match"];
var ids = ["", "free-shipping", "return-policy", "", "price-match"]    
var container = document.createElement('div');
container.className = 'planet-badges-outer-container';
var imgContainer = document.createElement('div');
imgContainer.innerHTML = '';
imgContainer.className = 'planet-img-container';
var y = document.querySelectorAll('.product-form__buttons')[0];
if(document.getElementsByClassName('planet-img-container').length == 0){
  y.appendChild(container)
  container.appendChild(imgContainer);
  
}

    var s = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
  <circle cx="7.5" cy="7.5" r="7" stroke="black"/>
  <rect x="7" y="6" width="1" height="5" fill="black"/>
  <rect x="7" y="4" width="1" height="1" fill="black"/>
</svg>`
for(var i = 0; i < imgSrcs.length; i++){
                    
    var img = document.createElement('div');
    img.innerHTML = '<div class="planet-badge-container" id="'+ids[i]+'"><img src="' + imgSrcs[i] +  '"><span class="badge'+i+'">'+badgeTexts[i]+ s +' </span></div>';
    imgContainer.appendChild(img);
    img.className = "planet-badges-container";
           
    
}  
 jQuery('.product__description.rte').eq(0).before(jQuery('div#stamped-main-widget'))    
jQuery('.product__description.rte').eq(0).before(jQuery('[data-pf-type="Stamped"]'))
   
    $('div#price-match').click(function(){
  $('.product-popup-modal__button').eq(0).click();
}); 

    $('div#free-shipping').click(function(){
  $('.product-popup-modal__button').eq(2).click();
}); 

    $('div#return-policy').click(function(){
  $('.product-popup-modal__button').eq(4).click();
}); 
});
  
  
  
  
  jQuery(document).ready(function(){

var ur = window.location.href;

Element.prototype.appendAfterThis = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
    
    var $odAtcInit = jQuery('[data-buy-buttons] [data-add-to-cart]').eq(0);
    var ctaCopy;
    if ($odAtcInit.length) {
      ctaCopy = $odAtcInit.prop('disabled') ? "Select Options" : "Add to Cart";
    } else if (jQuery('fieldset.js.product-form__input').length) {
      ctaCopy = "Select Options";
    } else {
      ctaCopy = "Add to Cart";
    }

  var lnk = '#';
  // PG1-33/PG1-43: prefer the oddit PDP title; fall back to the legacy theme title.
  var stickyCopy = jQuery('.oddit-section-main-product__title').eq(0).text() || jQuery('h1.product__title').eq(0).text();
  
var sticky = document.createElement('div');
sticky.innerHTML = '<div class="planet-st-container" id="planet-st-containerID"> <div class="planet-st-container__outer"> <div class="planet-st-container__inner"> <div class="planet-st-copy"><p>'+stickyCopy+'</p><div class="st-reviews"></div></div><div class="planet-st-item_column__button"><div class="st-price"></div><a href="'+lnk+'" class="planet-st-item__button">'+ctaCopy+'</a></div></div></div></div></div>';
var y = document.getElementsByTagName('body');
if (document.getElementsByClassName('planet-st-container').length == 0) {
    y[0].appendChild(sticky);
}
    // PG1-33/PG1-43: source the price from the oddit PDP price row (current +
    // compare-at) so the sticky bar mirrors the live site; fall back to the legacy
    // price element on older templates.
    var $odPrice = $('.oddit-section-main-product__price-row').eq(0);
    if ($odPrice.length) {
      $('.st-price').eq(0).html($odPrice.html());
    } else {
      $('.st-price').eq(0).html($('.product .price .price__sale').eq(0).html());
    }

    // PG1-33/PG1-43: mirror the PDP rating (stars + "based on N reviews") in the
    // sticky bar. Prefer the oddit reviews block; fall back to the Stamped badge.
    var $odReviews = jQuery('.oddit-section-main-product__reviews').eq(0);
    if ($odReviews.length) {
      jQuery('.st-reviews').eq(0).html($odReviews.html());
      jQuery('.st-reviews').eq(0).find('a').removeAttr('href');
      jQuery('.st-reviews').eq(0).off('click').on('click', function(){
        var w = document.querySelectorAll('div#stamped-main-widget');
        if (w.length) window.scrollTo({ top: w[0].offsetTop, behavior: 'smooth' });
      });
    } else {
      var sdsd = 0; var timersdsd = setInterval(function(){
        if($('span.stamped-product-reviews-badge.stamped-main-badge').length) {
          setTimeout(function(){
            jQuery('.st-reviews').eq(0).html(jQuery('span.stamped-product-reviews-badge.stamped-main-badge').html());
            $('.st-reviews').click(function(){
              window.scrollTo({
                top: document.querySelectorAll('div#stamped-main-widget')[0].offsetTop,
                behavior: 'smooth'
              });
            });
          }, 2000);
          clearInterval(timersdsd);
        }
        if( sdsd > 200){clearInterval(timersdsd);}
        sdsd++;
      }, 50);
    }
    
$('.planet-st-item__button').off('click').on('click', function(e){
  // PG1-33/PG1-43: it's an <a href="#">; stop it from jumping to the top of the page.
  e.preventDefault();

  var $odAtc = jQuery('[data-buy-buttons] [data-add-to-cart]').eq(0);
  if ($odAtc.length) {
    if (!$odAtc.prop('disabled')) {
      // A variant is selected and available -> add it to cart (delegated handler
      // on the oddit section picks up the bubbled click).
      $odAtc[0].click();
    } else {
      // Needs a selection -> scroll up to the buy/options area so the shopper can choose.
      var $target = jQuery('[data-buy-buttons]').eq(0);
      if (!$target.length) $target = jQuery('.oddit-section-main-product__pricing').eq(0);
      if ($target.length) {
        $('html, body').animate({ scrollTop: $target.offset().top - 120 }, 500);
      }
    }
    return;
  }

  // Legacy templates fallback
  if (jQuery('fieldset.js.product-form__input').length) {
    var $p = $('.price').eq(0);
    if ($p.length) $('html, body').animate({ scrollTop: $p.offset().top - 100 }, 500);
  } else {
    jQuery('button.buttonstyl.product-form__submit.button.button--full-width.button--primary').eq(0).click();
  }
});
    

  
var mc = window.matchMedia("(min-width: 767px)");

var elem = document.getElementById("planet-st-containerID");
function slideShow() {
    if (!elem) return; // PG1-33: sticky ATC removed
    elem.style.bottom = "0px";
    jQuery('body').addClass('planet-sticky');
}
function slideHide() {
    if (!elem) return; // PG1-33: sticky ATC removed
    elem.style.bottom = "-150px";
   jQuery('body').removeClass('planet-sticky');
}
  
jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
    // PG1-43: show the sticky ATC once scrolled past the buybox, and hide it
    // before the footer comes into view (so it never overlaps the footer).
    var $buybox = jQuery('[data-buy-buttons], .product-form__buttons').eq(0);
    var buyboxBottom = $buybox.length ? ($buybox.offset().top + $buybox.outerHeight()) : 0;
    var $footer = jQuery('.oddit-footer').last();
    var footerInView = $footer.length ? (y + jQuery(window).height() >= $footer.offset().top) : false;
     if (y > buyboxBottom && !footerInView) {
        slideShow();
    } else {
        slideHide();
    }

});
  }); 
}


var ur = window.location.href;
if(ur.includes('/collection')){
  jQuery(document).ready(function(){

      jQuery('.quick-view-button').click(function(){
  		var q = jQuery(this).closest('li');
        var qv = 0; var timerqv = setInterval(function(){
          if(q.find('.qview-button').length) {
		q.find('.qview-button').eq(0).click();
      clearInterval(timerqv);}if( qv > 200){clearInterval(timerqv);}qv++;}, 50);
        
      }); 
});
}       



var ur = window.location.href;
if(ur.includes('/cart')){
  jQuery(document).ready(function(){
var actualPrice = $('p.totals__subtotal-value').eq(0).html().split(' +')[0];
$('p.totals__subtotal-value').eq(0).html($('p.totals__subtotal-value').eq(0).html().replace(actualPrice, ('<b>'+actualPrice+'</b>')));
});



  jQuery(document).ready(function(){
 var atc = 0; var timeratc = setInterval(function(){
  if(jQuery('.simple-badges').length == 0) {
  
      
    // div ng popup  
    // take note class at id
  jQuery('body').append(jQuery(`<div class="simple-popup simple-shipping-popup">
  <div class="popup-content">
    <div class="popup-title">Shipping & Returns <span class="simple-close">×</span></div>
    <div class="popup-p">
      <div class="popup-contentt">
        <div class="product-popup-modal__content-info">
            
            <p><strong>Order Confirmation: </strong></p>
  <p>As soon as you place your order, you will receive an order confirmation e-mail. This means that we have received your order in our system and pre-authorized your credit card for the purchase. As soon as we receive your order, we automatically reach out to our suppliers to confirm that it is in stock and available for immediate shipment. If your item is on backorder or unavailable, we will void the pre-authorization and reach out to you via e-mail. If your item(s) are available for immediate shipment (within 5 business days), we will process the charges and submit the order for shipment.</p>
  <p><strong>Order Shipment:</strong></p>
  <p>If your order is stock and we process the charges to your credit card, it will ship within five business days from the date of your order. We will send you tracking information within 24 hours of your order leaving the warehouse to the e-mail address you provided when checking out. If you do not receive tracking information from us within six business days of your order, feel free to follow up with us at orders@planetgreenhouses.com. If your request for a return is granted, you will be required to pay a 25% restocking fee and full cost of return shipping, and also the full cost of shipping to and from the destination.</p>
  <p>To be eligible for a return, your item must be in the same condition that you received it, unworn or unused, with tags, and in its original packaging. You’ll also need the receipt or proof of purchase. To start a return, you can contact us at sales@planetgreenhouse.com. If your return is accepted, we’ll send you a return shipping label, as well as instructions on how and where to send your package. Items sent back to us without first requesting a return will not be accepted. You can always contact us for any return question at sales@planetgreenhouse.com.</p>
  <p><strong> Damages:</strong></p>
  <p>Please inspect your order upon reception and contact us immediately if the item is defective, damaged or if you receive the wrong item so that we can evaluate the issue and make it right. If you find there are any damages due to shipping, please make sure to report them and refuse delivery. You will not be able to make claims for shipping after the product has already been inspected from the courier.</p>
  <p><strong></strong> Refunds We will notify you once we’ve received and inspected your return, and let you know if the refund was approved or not. If approved, you’ll be automatically refunded on your original payment method. Please remember it can take some time for your bank or credit card company to process and post the refund too. Damages: Please inspect the packaging of your item(s) when they arrive, if you notice any damage you should make note of it when signing for delivery. If your item(s) do arrived damaged, please send photos to returns@planetgreenhouses.com and we will process an insurance claim on your behalf.</p>
  <p><strong>Cancellations &amp; Refunds:</strong></p>
  <p>All orders cancelled after 48 hours are subject to a 3% administration fee, whether or not your order has shipped. If you order has shipped, you (the buyer) will also be responsible for actual return shipping charges.</p>
  <p>Refunds will only be issued to the original credit card that you use when placing your order. Many of our items are heavy items and will not be able to be returned due to buyers remorse.</p>
  <p>All sales will be final in this case. If there is a part or piece missing, we ask the customer takes a photo of the shipped item and we will immediately try to have the missing part shipped if we have it in stock. in certain situations, we will accept an item to be returned when submitted to our RMA department.</p>
  <p>The buyer will be responsible for full return shipping cost and up to a 25% restocking fee. This must be approved by our RMA department first.</p>
  <p><strong> Return Process</strong></p>
  <ul>
  <li>Contact our team at support@planetgreenhouse.com in order to process your return.</li>
  <li>We will need to issue you an RMA in order to process your return</li>
  <li>You will have 30 days from the date of receipt to issue a return of your item. · Item must still be in new condition and in the packaging in which it was received.</li>
  <li>Returns will have up to a 25% restocking fee.</li>
  <li>Buyer will be responsible for 100% of the return shipping fee’s.&nbsp;</li>
  <li>It may take up to 30 days for your refund to be processed by our team.</li>
  </ul>
          </div>
      </div>
    </div>
  </div>
</div>
`))
    jQuery('body').append(jQuery(`<div class="simple-popup simple-return-popup">
  <div class="popup-content">
    <div class="popup-title">Returns/Exchanges <span class="simple-close">×</span></div>
    <div class="popup-p">
      <div class="popup-contentt">
        <div class="product-popup-modal__content-info">
            
            <p><strong>Damages:</strong></p>
  <p><span style="font-weight: 400;">Please inspect the packaging of your item(s) when they arrive, if you notice any damage you should make note of it when signing for delivery.&nbsp; If your item(s) do arrived damaged, please send photos to </span><span style="font-weight: 400;">returns@planetgreenhouses.com</span><span style="font-weight: 400;"> and we will process an insurance claim on your behalf.</span></p>
  <p><strong>Cancellations &amp; Refunds:</strong></p>
  <p><span style="font-weight: 400;">All orders cancelled after 48 hours are subject to a $20 administration fee, whether or not your order has shipped.&nbsp; If you order has shipped, you (the buyer) will also be responsible for actual return shipping charges. Refunds will only be issued to the original credit card that you use when placing your order.</span></p>
  <p><span style="font-weight: 400;">Many of our items are heavy items and will not be able to be returned due to buyers remorse.&nbsp; All sales will be final in this case.</span></p>
  <p>If there is a part or piece missing, we ask the customer takes a photo of the shipped item and we will immediately try to have the missing part shipped if we have it in stock.&nbsp;&nbsp;</p>
  <p>in certain situations, we will accept an item to be returned when submitted to our RMA department.&nbsp; The buyer will be responsible for full return shipping cost and a 25</p>
  <p>25% restocking fee. This must be approved by our RMA department first.</p>
          </div>
      </div>
    </div>
  </div>
</div>
`))


      jQuery('body').append(jQuery(`<div class="simple-popup simple-price-popup">
  <div class="popup-content">
    <div class="popup-title">Price Match <span class="simple-close">×</span></div>
    <div class="popup-p">
      <div class="popup-contentt">
        <div class="product-popup-modal__content-info">
            
            <p><span style="font-weight: 400;">We work very hard to ensure that we offer the absolute best prices online.&nbsp; If you find another online store that offers a lower price then us within six months of your purchase date please let us know and we will refund your original payment for the difference.&nbsp; We want you to feel confident that you are getting the absolute best price for the product you are ordering.&nbsp; If you find that our own website has a lower price for the same item you have ordered within six months of your purchase date will refund the difference as well.</span></p>
  <p><span style="font-weight: 400;">To request your partial refund simply e-mail us a link to the same product on our website, or on our competitors website within six months from the date of your order and we will process the credit accordingly.</span></p>
  <p><span style="font-weight: 400;">Our 100% Price Guarantee has some limitations:</span></p>
  <ul>
  <li style="font-weight: 400;"><span style="font-weight: 400;">You must purchase the item from our website before requesting your Price Match Guarantee</span></li>
  <li style="font-weight: 400;"><span style="font-weight: 400;">Promotions such as rebates and buy one, get one free offers are not eligible</span></li>
  <li style="font-weight: 400;"><span style="font-weight: 400;">The item must be in stock on the competitors website</span></li>
  <li style="font-weight: 400;"><span style="font-weight: 400;">The competitor must be an online store, they may not have a retail location</span></li>
  <li style="font-weight: 400;"><span style="font-weight: 400;">The website can not be a discounter or auction website (ie; eBay, overstock, etc..)</span></li>
  <li style="font-weight: 400;"><span style="font-weight: 400;">The competitor must be an Authorized Retailer of the product in question</span></li>
  <li style="font-weight: 400;"><span style="font-weight: 400;">The Price Match Guarantee includes the item price and the shipping charges, it excludes sales tax</span></li>
  </ul>
          </div>
      </div>
    </div>
  </div>
</div>

`))
    
  jQuery('div#free-shipping').click(function(e){
  e.stopPropagation();
    e.preventDefault
  jQuery('.simple-shipping-popup').eq(0).addClass('open')
    jQuery('body').addClass('popup');
  });   
  
        jQuery('div#return-policy').click(function(e){
  e.stopPropagation();
           e.preventDefault();
  jQuery('.simple-return-popup').eq(0).addClass('open')
          jQuery('body').addClass('popup');
  });   


  jQuery('div#price-match').click(function(e){
  e.stopPropagation();
           e.preventDefault();
  jQuery('.simple-price-popup').eq(0).addClass('open')
    jQuery('body').addClass('popup');
  });       
 jQuery('span.simple-close').click(function(){
  jQuery(this).parent().parent().parent().removeClass('open')
   jQuery('body').removeClass('popup');
}); 
    
    jQuery('.simple-popup').click(function(event){
  event.stopPropagation();
});
   jQuery(window).click(function() {
     if(jQuery('body > .open').length){
       jQuery('span.simple-close').click();
     }
  
});
clearInterval(timeratc);}if( atc > 200){clearInterval(timeratc);}atc++;}, 50);
});    
}




